import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import { useSettingsStore } from "../../store/settings-store";
import { EmptyState } from "../../../../../../components/widgets/empty-state/EmptyState";

function PdfViewer() {
  const { fileUrl } = useSettingsStore();
  const newPlugin = defaultLayoutPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();

  if (!fileUrl) {
    return <EmptyState text="No document to display" />;
  }

  return (
    <div className="pdf-viewer-layout">
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <Viewer
          fileUrl={fileUrl}
          plugins={[newPlugin, pageNavigationPluginInstance]}
        />
      </Worker>
    </div>
  );
}

export { PdfViewer };
